export class APIError extends Error {
    readonly payload: unknown;
    readonly status?: number;

    constructor(message: string, payload?: unknown, status?: number) {
        super(message, payload instanceof Error ? { cause: payload } : undefined);
        this.name = 'APIError';
        this.payload = payload instanceof APIError ? payload.payload : payload;
        this.status = status ?? (payload instanceof APIError ? payload.status : undefined);
    }
}

export const getErrorStatus = (error: unknown): number | undefined => {
    if (error && typeof error === 'object' && 'status' in error && typeof error.status === 'number') {
        return error.status;
    }
};
